import { createActionConst } from '../../../utils/action.utils';

const PERSONAL_NOTE_NAMESPACE = 'PERSONAL_NOTE';

export const STORE_PERSONAL_NOTE = createActionConst(PERSONAL_NOTE_NAMESPACE, 'STORE_PERSONAL_NOTE');
export const CLEAR_PERSONAL_NOTE = createActionConst(PERSONAL_NOTE_NAMESPACE, 'CLEAR_PERSONAL_NOTE');
